import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import { ComplianceSummaryFeatureState } from '../interfaces/shared.interface';
import { ComplianceSummaryAPIActions } from '../actions/compliance-summary.actions';

const initialState: ComplianceSummaryFeatureState = {
  dueNow: 0,
  upToDate: 0,
  updateSoon: 0,
  soonestExpiryDate: '',
};

const reducer: ActionReducer<ComplianceSummaryFeatureState> = createReducer(
  initialState,
  on(
    ComplianceSummaryAPIActions.loadedComplianceSummarySuccessfully,
    (state, { complianceSummary }): ComplianceSummaryFeatureState => ({
      ...state,
      ...complianceSummary,
    }),
  ),
);

export function complianceSummaryReducer(
  state: ComplianceSummaryFeatureState = initialState,
  action: Action,
): ComplianceSummaryFeatureState {
  return reducer(state, action);
}
